import * as z from "zod";
import {
  FlowContentNodeSchema,
  type FlowContentNode,
} from "../flow-content-node-schema";
import { SectionLockAttrsSchema } from "../lock-types-schema";

/**
 * Section node - a numbered block for organizing content.
 * Section numbers are calculated dynamically based on position in the document.
 */
const SectionNodeSchema_ = z.object({
  type: z.literal("section"),
  content: z.array(z.lazy(() => FlowContentNodeSchema)),
  lock: SectionLockAttrsSchema.optional(),
});

/** Base type from schema inference (no index signature) */
type SectionNodeBase = Omit<z.infer<typeof SectionNodeSchema_>, "content"> & {
  content: FlowContentNode[];
};

/** Full type with index signature for FlowContentNode compatibility */
export type SectionNode = SectionNodeBase & { [key: string]: unknown };

export const SectionNodeSchema: z.ZodType<SectionNode> = SectionNodeSchema_;

/**
 * Type guard for section nodes.
 */
export function isSectionNode(node: unknown): node is SectionNode {
  return (
    typeof node === "object" &&
    node !== null &&
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    (node as Record<string, unknown>).type === "section"
  );
}
